/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_S4Inputs */

const en_tut_santai_s4 = /** @type {(inputs: Tut_Santai_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A room manager may paste a **Spotify Jam** invite link with **Simpan tautan**; people in the room open it with **Buka undangan Spotify di tab baru**.`)
};

const id_tut_santai_s4 = /** @type {(inputs: Tut_Santai_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengelola ruang boleh menempelkan tautan undangan **Spotify Jam** lewat **Simpan tautan**; anggota di ruang membukanya lewat **Buka undangan Spotify di tab baru**.`)
};

/**
* | output |
* | --- |
* | "A room manager may paste a **Spotify Jam** invite link with **Simpan tautan**; people in the room open it with **Buka undangan Spotify di tab baru**." |
*
* @param {Tut_Santai_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_s4 = /** @type {((inputs?: Tut_Santai_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_s4(inputs)
	return en_tut_santai_s4(inputs)
});